import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var SelectionCanvas = function (props) {
    var selectionDim = props.selectionDim;
    if (selectionDim === null || (selectionDim === null || selectionDim === void 0 ? void 0 : selectionDim.y2) === null || (selectionDim === null || selectionDim === void 0 ? void 0 : selectionDim.x2) === null) {
        return _jsx(_Fragment, {});
    }
    var lassoPoints = selectionDim.points;
    // Lasso mode: render an SVG polygon following the drawn path
    if (lassoPoints && lassoPoints.length > 1) {
        var pointsStr = lassoPoints.map(function (p) { return "".concat(p.x, ",").concat(p.y); }).join(' ');
        return (_jsx("svg", { className: "selectionLasso", style: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                overflow: 'visible',
            }, children: _jsx("polyline", { points: pointsStr, fill: "none", stroke: "rgba(0, 120, 215, 0.6)", strokeWidth: "3", strokeDasharray: "8 6", strokeLinejoin: "round", strokeLinecap: "round" }) }));
    }
    return _jsx(_Fragment, {});
};
export default SelectionCanvas;
